import { MutationHookOptions, useMutation } from '@apollo/client';

import operation from './createManagedAccountMutation.graphql';

export const useCreateManagedAccountMutation = (
  opts: MutationHookOptions<
    CreateManagedPlatformAccountMutationPayload,
    CreateManagedPlatformAccountMutationInput
  >,
) =>
  useMutation<
    CreateManagedPlatformAccountMutationPayload,
    CreateManagedPlatformAccountMutationInput
  >(operation, opts);
